import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import './FormActionButtons.css';

const FormActionButtons = ({
  onCancel,
  disabled = false,
  /** When true, Cancel is disabled and styled (e.g. during submit so navigation cannot race the request). */
  cancelDisabled = false,
  isSubmitting = false,
  isEditMode = false,
  cancelLabel = 'Cancel',
  /** `"inventory"` sets primary to #0F172B via CSS variables on the wrapper */
  variant = ''
}) => {
  const wrapClass = ['shared-form-action-buttons', variant === 'inventory' && 'shared-form-action-buttons--inventory']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapClass}>
      <button
        type="button"
        className="shared-form-action-btn shared-form-action-btn-cancel"
        onClick={onCancel}
        disabled={cancelDisabled}
      >
        {cancelLabel}
      </button>
      <button
        type="submit"
        className="shared-form-action-btn shared-form-action-btn-add"
        disabled={disabled}
      >
        {isSubmitting ? (
          <>
            <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
            {isEditMode ? 'Updating...' : 'Adding...'}
          </>
        ) : (
          <>{isEditMode ? 'Update' : 'Add'}</>
        )}
      </button>
    </div>
  );
};

export default FormActionButtons;
